import { BaseMappingStep } from './BaseMappingStep'

export class OptionalMappingStep extends BaseMappingStep {
  protected headers = ['Optional Field', 'User Field']
}
